import { useState } from 'react';

import { useLocation } from 'react-router-dom';

import { toast } from 'react-toastify';

import cx from 'classnames';

import Modal from '../../../modal/Modal';

import { useGetInterventionLevelWiseQuestion } from '../queries';

import { usePostTeacherIntervention } from '../mutation';

import styles from './styles.module.scss';

const InterventionQuestionModal = ({
  level = "Level 3",
  visible,
  domainCategoryId,
  domainMasterId,
  inputLevelId,
  classroomObservationID,
  onClose,
  setVisible,
  getInteventionMarkings
}) => {
    const [answers, setAnswers] = useState([]);
        
    const location = useLocation();

    const studentData = location.state?.data;

    const {gradeId , studentId , userId} = studentData || {};

    const languageId = localStorage.getItem('l_id');
    
    const {data , isLoading} = useGetInterventionLevelWiseQuestion({domainCategoryId ,domainMasterId , inputLevelId , 
        classroomObservationId:classroomObservationID , gradeId , languageId});

    const {mutate, isPending} = usePostTeacherIntervention()
    
    const { response = []} = data || {};
    const questions = Array.isArray(response) ? response : [];

    const handleChange = (question, option, questionIndex) => {
      const questionKey = question?.questionId || question?.id || questionIndex;
      const optionKey = option?.optionId || option?.id;

      setAnswers((prevAnswers) => {
        const updatedAnswers = prevAnswers.filter(
          (answer) => answer.questionID !== questionKey
        );

        return [
          ...updatedAnswers,
          {
            questionID: questionKey,
            optionID: optionKey,
          },
        ];
      });
    };

   

    const handleSubmit = () => {
    mutate({
    userID:userId,
    studentID:studentId,
    domainCategoryID:domainCategoryId,
    domainMasterID:domainMasterId,
    classroomObservationID,
    inputLevelID:inputLevelId,
    input:answers
    },{
        onSuccess(data){
        const {data:userData} = data || {};

        const {status} = userData || {};

        if(!status){
            throw new Error()
        }

        toast.success('Question submitted successfully')
        setTimeout(() => {
            setVisible(false);
             getInteventionMarkings();
        }, 2000);

        },
        onError(error){
          const serverMessage = error?.response?.data?.message;
        const finalMsg =
          serverMessage || error?.message || "Something went wrong";
          
        toast.error(finalMsg);
        }
    })
    };

    const isSubmitDisabled = questions.length === 0 || answers.length !== questions.length;
    
  return (
    <Modal visible={visible}>
    <div className={styles.assessment}>
      {/* Header */}
      <div className={styles['assessment__header']}>
        <h3>Answer the following questions to mark level</h3>
        <span className={styles["badge"]}>{level}</span>
      </div>

      {
        response.length
        ?
              <div className={styles["assessment__body"]}>
        {
        isLoading ? (
          <p className={styles["question__text"]}>Loading...</p>
        ) : questions.map((item , index)=>(
        <div className={styles["question"]} key={item?.questionId || item?.id || index}>
          <p className={styles["question__title"]}>Question {index + 1}</p>
          <p className={styles["question__text"]}>
            {item?.questionName}
          </p>
        <div className={styles["options"]}>
           { item?.options?.map((optionItem)=>(
            
            <label key={optionItem?.optionId || optionItem?.id || optionItem?.optionName}>
              <input
                type="radio"
                name={`question-${item?.questionId || item?.id || index}`}
                checked={answers.some(
                  (answer) =>
                    answer.questionID === (item?.questionId || item?.id || index) &&
                    answer.optionID === (optionItem?.optionId || optionItem?.id)
                )}
                onChange={() => handleChange(item, optionItem, index)}
              />
              {optionItem.optionName}
            </label>
            ))}
            </div>
        </div>
        ))
        }
      </div>
        :
        <p>No Question found.</p>
      }


      {/* Footer */}
      <div className={styles["assessment__footer"]}>
        <button className={cx(styles["btn--outline"],styles.btn)} onClick={onClose}>
          Close
        </button>

        <button
        className={cx(styles["btn--primary"],styles.btn)}
        disabled={isSubmitDisabled || isPending}
        onClick={handleSubmit}
        >
          {isPending ? 'submitting...' :`Mark Progress`}
        </button>
      </div>
    </div>
    </Modal>
  );
};

export default InterventionQuestionModal;
